var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _vm.uploadedThumbnail.url
      ? _c("div", {
          staticClass: "fa fa-trash",
          attrs: { title: "Remove this thumbnail" },
          on: {
            click: function($event) {
              _vm.uploadedThumbnail.url = null
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropzone dropzone-area show",
        class: {
          "dz-disabled": _vm.uploadedThumbnail.isDropped,
          "dz-processed": _vm.uploadedThumbnail.url
        },
        staticStyle: { height: "100%" },
        attrs: { id: _vm.elem_id, title: "Drop files here or click to upload." }
      },
      [
        _c("div", { staticClass: "dz-message" }, [
          !_vm.for_podcast
            ? _c(
                "div",
                { staticClass: "description-txt add-photo-icon c-dz-progress" },
                [_vm._v(_vm._s(_vm.status || "Upload"))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.for_podcast
            ? _c("div", { staticClass: "btn-browse btn-sm c-dz-progress" }, [
                _vm._v(_vm._s(_vm.status || "Upload"))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.for_podcast
            ? _c("div", { staticClass: "description-txt sub-info" }, [
                _vm._v("Drop files here or click to upload.")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasError,
                  expression: "hasError"
                }
              ],
              staticClass: "description-txt error show"
            },
            [
              _c("div", { staticClass: "error-message" }, [
                _vm._v(_vm._s(_vm.errorMessage || "Something went wrong"))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _vm.uploadedThumbnail.url
          ? _c("img", { attrs: { src: _vm.uploadedThumbnail.url } })
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }